// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__-JUxZ","errors":"Errors_errors__w4eCU"};